import { ref, computed } from 'vue'
import { defineStore } from 'pinia'


export const useDataScore = defineStore('score_store', () => {

	const isStart = ref(false)
	const totalScore = ref(5)
	const arrayPersents = ref([0, 0, 0, 0, 0])

	function init() {
		if (!isStart.value) {

			const array = window.appScores.arraySteps

			if (array.length !== 5)
				return 5

			let total = 0
			let score = 0

			for (let i = 0; i < array.length; i++) {
				total += array[i]
				score += array[i] * (i + 1)
			}

			for (let i = 0; i < array.length; i++) {
				arrayPersents.value[i] = array[i] / total
			}

			totalScore.value = (score / total).toFixed(1).toString()

			isStart.value = true
		}
	}



	return { init, totalScore, arrayPersents }
})
